import * as styles from '../styles/contacts.module.scss';

import React, { useRef, useState } from 'react';

import EmailIcon from '-!svg-react-loader!../assets/email-dark.svg';
import GoogleMap from '../components/GoogleMap';
import Layout from '../components/Layout';
import LocationIcon from '-!svg-react-loader!../assets/location-dark.svg';
import PhoneIcon from '-!svg-react-loader!../assets/phone-dark.svg';
import ScrollToTopButton from '../components/ScrollToTopButton/ScrollToTopButton';
import SectionTitle from '../components/SectionTitle';
import Seo from '../components/SEO';

const Contacts = () => {
  const [selectedLocation, setSelectedLocation] = useState('gerole');
  const form = useRef();

  const pilartPhoneNumber = '+39 3200318685';
  const pilartEmail = 'carroroxana@gmail.com';

  const moveartPhoneNumber = '+39 3514848091';
  const moveartEmail = 'moveartssd@gmail.com';

  const address = 'Via Gerole 29, Stezzano (BG)';

  const sendEmail = async (e) => {
    e.preventDefault();

    return window.open(
      `https://api.whatsapp.com/send?phone=${pilartPhoneNumber.replace(' ', '')}&text=${form.current['message'].value}`
    );
  };

  return (
    <Layout>
      <Seo title={'Pilart & MoveArt - Contattaci!'} description={'Scopri dove trovarci e molto altro!'} />
      <SectionTitle title="CONTATTI" />
      <section className={styles.contactSection}>
        <div>
          <LocationIcon className={styles.contactsIcon} />
          <p>LA NOSTRA SEDE PRINCIPALE</p>
          <span>&nbsp;&nbsp;{address}</span>
        </div>
        <div>
          <PhoneIcon className={styles.contactsIcon} />
          <p>NUMERI DI TELEFONO</p>
          <div style={{ display: 'grid', gap: '10px' }}>
            <span>Pil Art: {pilartPhoneNumber}</span>
            <span>Move Art: {moveartPhoneNumber}</span>
          </div>
        </div>
        <div>
          <EmailIcon className={styles.contactsIcon} />
          <p>EMAIL</p>
          <div style={{ display: 'grid', gap: '10px' }}>
            <span>Pil Art: {pilartEmail}</span>
            <span>Move Art: {moveartEmail}</span>
          </div>
        </div>
      </section>
      <section className={styles.formAndMapsSection}>
        <div>
          <h2>CONTATTACI ORA SU WHATSAPP!</h2>
          <br />

          <form ref={form} onSubmit={sendEmail} className={styles.contactsForm} action="#">
            <textarea name="message" rows="15" cols="100" placeholder="Scrivi il tuo messaggio" required />
            <button type="submit" value="send">
              Invia
            </button>
          </form>
        </div>
        <div>
          <h2>SIAMO QUI!</h2>
          <p>SELEZIONA UNA PALESTRA:</p>

          <select name="locations" onChange={({ target }) => setSelectedLocation(target.value)}>
            <option value="gerole">Stezzano - Gerole</option>
            <option value="impianti_sportivi">Stezzano - Impanti Sportivi</option>
            <option value="caroli">Stezzano - Caroli</option>
            <option value="don_minzoni">Stezzano - Don Minzoni</option>
            <option value="osio_centro_giovanile">Osio Sotto - Centro Giovanile</option>
            <option value="osio_campus">Osio Sotto - Palestra Campus</option>
          </select>

          <br />
          <br />

          <GoogleMap location={selectedLocation} />
        </div>
      </section>
      <ScrollToTopButton />
    </Layout>
  );
};

export default Contacts;
